module.exports = __webpack_public_path__ + "static/media/user (1).10a93f10.svg";